import classnames from 'classnames';
import { AxiosError } from 'axios';
import React, { useState } from 'react';
import { Button, Container, Table } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import BackgroundImages from 'v2/common/Background/BackgroundImages';
import Input from 'v2/form/Input/Input';
import restFactory from 'v2/utils/restFactory';

interface TopProvider {
  id: number;
  classification: string;
  keyword: string;
  name: string;
  phrase: string;
  score: string;
}

interface TopDataProviderQueryForm {
  text: string;
  keywords: string;
  phrase_exp: number;
  keyword_exp: number;
}

const TopProviders = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [topProviders, setTopProviders] = useState<TopProvider[]>([]);
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<TopDataProviderQueryForm>({
    mode: 'onChange',
    defaultValues: {},
  });

  const onSubmit = async (formData: TopDataProviderQueryForm) => {
    if (!formData.text && !formData.keywords) {
      setError('Please enter a text or keywords');
      return;
    }
    setError('');
    setLoading(true);
    try {
      const topProviders = await restFactory.get<TopProvider[]>(
        '/dj/api/v1/top_providers/',
        { ...formData, keywords: formData.keywords.split('|') }
      );
      setTopProviders(topProviders);
      setLoading(false);
    } catch (error) {
      toast.error((error as AxiosError).message);
      setLoading(false);
    }
  };

  return (
    <Container className="mt-4 fix-bg-images" fluid="xl">
      <BackgroundImages showTopImage={false} />
      <h1>Top Providers</h1>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form-group">
          <Input
            label="Text"
            type="text"
            register={register('text')}
            error={errors?.text?.message}
            maxLength={64}
            autoComplete="off"
          />
        </div>
        <div className="form-group">
          <Input
            label="Keywords"
            type="text"
            register={register('keywords')}
            error={errors?.keywords?.message}
            maxLength={64}
            autoComplete="off"
          />
        </div>
        <div className="d-flex w-100">
          <div className="form-group w-50 mr-2">
            <Input
              label="Phrase exp"
              type="number"
              register={register('phrase_exp')}
              error={errors?.phrase_exp?.message}
              autoComplete="off"
              step="0.1"
            />
          </div>
          <div className="form-group w-50 ml-2">
            <Input
              label="Keyword exp"
              type="number"
              register={register('keyword_exp')}
              error={errors?.keyword_exp?.message}
              autoComplete="off"
              step="0.1"
            />
          </div>
        </div>

        {error ? <p className="text-danger">{error}</p> : null}
        <Button variant="primary" type="submit" disabled={loading}>
          {loading ? 'Loading...' : 'Load'}
        </Button>
      </form>
      <div className={classnames('pt-5', { 'opacity-05': loading })}>
        <Table hover responsive>
          <thead>
            <tr>
              <th>Id</th>
              <th>Total Score</th>
              <th>Name</th>
              <th>Phrase score</th>
              <th>Keyword score</th>
            </tr>
          </thead>
          <tbody>
            {topProviders?.map((provider) => (
              <tr key={provider.id}>
                <td>{provider.id}</td>
                <td>{provider.score}</td>
                <td>{provider.name}</td>
                <td>{provider.phrase}</td>
                <td>{provider.keyword}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </Container>
  );
};

export default TopProviders;
